module.exports = __webpack_public_path__ + "static/media/laptop.bf358fef.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/laptop.png
// module id = 242
// module chunks = 0